import { SeatAssignment, SystemSettings } from '../types';

// 開発環境と本番環境でAPIエンドポイントを切り替え
// 開発環境では wrangler dev が提供するエンドポイント、本番環境ではCloudflare Workersエンドポイントを使用
const isDevelopment = process.env.NODE_ENV === 'development';
const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8787/api' // ローカル開発用Wranglerエンドポイント
  : 'https://random-sekigime.new033.workers.dev/api'; // 正しい本番環境のCloudflare WorkersドメインとAPIパスを指定

export async function saveSeatAssignment(assignment: Omit<SeatAssignment, 'id' | 'timestamp'>): Promise<SeatAssignment> {
  try {
    const response = await fetch(`${API_BASE_URL}/seat-assignments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(assignment),
    });
    
    if (!response.ok) {
      throw new Error('Failed to save seat assignment');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error saving seat assignment:', error);
    throw error;
  }
}

export async function getSeatAssignment(seatNumber: number): Promise<SeatAssignment | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/seat-assignments/${seatNumber}`);
    
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('Failed to get seat assignment');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error getting seat assignment:', error);
    throw error;
  }
}

export async function getAllSeatAssignments(): Promise<SeatAssignment[]> {
  try {
    const response = await fetch(`${API_BASE_URL}/seat-assignments`);
    
    if (!response.ok) {
      throw new Error('Failed to get seat assignments');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error getting seat assignments:', error);
    throw error;
  }
}

export async function clearAllSeatAssignments(): Promise<void> {
  try {
    const response = await fetch(`${API_BASE_URL}/seat-assignments`, {
      method: 'DELETE',
    });
    
    if (!response.ok) {
      throw new Error('Failed to clear seat assignments');
    }
  } catch (error) {
    console.error('Error clearing seat assignments:', error);
    throw error;
  }
}

export async function saveSettings(settings: SystemSettings): Promise<SystemSettings> {
  try {
    const response = await fetch(`${API_BASE_URL}/settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(settings),
    });
    
    if (!response.ok) {
      throw new Error('Failed to save settings');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error saving settings:', error);
    throw error;
  }
}

export async function getSettings(): Promise<SystemSettings> {
  try {
    const response = await fetch(`${API_BASE_URL}/settings`);
    
    if (!response.ok) {
      if (response.status === 404) {
        // デフォルト設定を返す
        return { totalSeats: 30 };
      }
      throw new Error('Failed to get settings');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error getting settings:', error);
    // エラー時はデフォルト設定を返す
    return { totalSeats: 30 };
  }
} 